import $ from 'jquery';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

if( $( '.amenities-map-section' ).length ){
  mapboxgl.accessToken = 'pk.eyJ1IjoiYXZpbGxpYS1tb3JuaW5ndmlldyIsImEiOiJjbDFmZmF0c3cxMHV1M21uNHJxdHd2NmFyIn0.L3tW0xEoPKHlmJvv3rE6Hg';
  const mapInfo = document.querySelectorAll( '.map-info' )
  
  
  const map = new mapboxgl.Map( {
  
  container: 'map', // container ID
  style: 'mapbox://styles/avillia-morningview/cl1fisqyk005d15ldoss8hecm', // style URL
  center: [-119.2101966, 50.2354403], // starting position [lng, lat]
  zoom: 10.6, // starting zoom

  } );

  const morningViewDiv = document.createElement( 'div' )
  morningViewDiv.className = 'morning-view-logo';

  const morningViewPopUp = new mapboxgl.Popup( { offset: 2 } ) // add popups
    .setHTML(
      `<h2 class="headline-medium map-box-heading">Morning View</h2>`
    )

  const morningViewMarker = new mapboxgl.Marker( morningViewDiv )
    .setLngLat( [-119.242556, 50.244083] )
    .setPopup( morningViewPopUp )
    .addTo( map );

  mapInfo.forEach( ( elem, index ) => {

    // Create Marker Element
    const el = document.createElement( 'div' )
    el.className = 'marker'
    el.dataset.slug = elem.dataset.slug

    // Create Number for Marker Element
    const mapMarkerNumber = document.createElement( 'p' )
    mapMarkerNumber.className = 'map-marker-number'
    mapMarkerNumber.textContent = $( mapInfo ).find( '.map-number' )[index].textContent
    
    el.appendChild( mapMarkerNumber ) // Add to Marker Element

    const popUp = new mapboxgl.Popup( { offset: 2 } ) // add popups
    .setHTML(
      `<h2 class="headline-medium map-box-heading">${ $( mapInfo ).find( '.map-title' )[index].textContent }</h2>`
    )

    // Create a new marker.
    const marker = new mapboxgl.Marker(el)
    .setLngLat( [$( mapInfo ).find( '.map-lon' )[index].textContent, $( mapInfo ).find( '.map-lat' )[index].textContent] )
    .setPopup( popUp )
    .addTo( map );
    
  } )

  // Display Markers When Legend Items are Clicked
  const legendItem = document.querySelectorAll( '.map-legend-title-container' )
  const legendMarker = document.querySelectorAll( '.marker' )

  legendMarker.forEach( ( elem, index ) => {

    elem.addEventListener('click', function () {
      map.flyTo({
        center: [$( mapInfo ).find( '.map-lon' )[index].textContent, $( mapInfo ).find( '.map-lat' )[index].textContent],
        zoom: 15,
      })
    })

    $( legendItem ).on( 'click', function() {

      map.flyTo({
        center: [-119.2101966, 50.2354403],
        zoom: 10.6,
      })

      if( $(this).data().slug === $(elem).data().slug ) {
        $(elem).toggleClass( 'marker-toggle' )
        $( '.map-box-heading' ).parent().remove()
      } else {
        $(elem).removeClass( 'marker-toggle' )
      }
    } )
    
  } )

  

  // Linking Legend Marker to Pop-Up on Map
  const mapLegendItem = document.querySelectorAll( '.map-legend-item' )

  mapLegendItem.forEach( ( elem, index ) => {
    elem.addEventListener( 'click', () => {

      $( '.mapboxgl-popup' ).remove() // Remove all existing pop ups

      // Add popup
      const legendPopUp = new mapboxgl.Popup( { offset: 2, focusAfterOpen: false } )
      .setHTML(
        `<h2 class="legend-popup headline-medium map-box-heading">${ $( mapInfo ).find( '.map-title' )[index].textContent }</h2>`
      )
      .setLngLat([$( mapInfo ).find( '.map-lon' )[index].textContent, $( mapInfo ).find( '.map-lat' )[index].textContent])
      .addTo( map )

      map.flyTo({
        center:[$( mapInfo ).find( '.map-lon' )[index].textContent, $( mapInfo ).find( '.map-lat' )[index].textContent],
        zoom: 15
      })

    } )
  } )

  // Accordion
  $( '.accordion .title' ).on( 'click', function( e ) {
    e.preventDefault();

    var $this = $( this );
    var $accordion = $this.parent();
    var $content = $this.next();

    $accordion.parent().find( '.content' ).css( 'max-height', '0' );

    if ($accordion.hasClass( 'open' )) {
      $accordion.removeClass( 'open' );
    } else {
      $accordion.siblings().removeClass( 'open' );
      $accordion.addClass( 'open' );
      $content.css( 'max-height', $content[0].scrollHeight );
    }
  });

}